import { render } from "./AddFournisseur.vue?vue&type=template&id=3e8bd8aa&scoped=true&ts=true"
import script from "./AddFournisseur.vue?vue&type=script&lang=ts"
export * from "./AddFournisseur.vue?vue&type=script&lang=ts"

import "./AddFournisseur.vue?vue&type=style&index=0&id=3e8bd8aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8bd8aa"]])

export default __exports__